import { useSelector } from 'react-redux';
import {
    getObjectSelectedData, getObjectSelectedClient, getObjectSelectedPlatform, getObjectSelected,
} from './object-selected.state';

export const useObjectSelected = () => {
    const objectSelected = useSelector(getObjectSelectedData);
    const clientSelected = useSelector(getObjectSelectedClient);
    const platformSelected = useSelector(getObjectSelectedPlatform);
    const selected = useSelector(getObjectSelected);

    return {
        objectSelected,
        clientSelected,
        platformSelected,
        selected,
    };
};
